import {requestFetch} from 'models/Autobatcher';
import {loadingCompleted, loadingFailed, loadingStarted} from 'models/LoadingStateReduxActions';
import * as ModelActions from 'redux-stores/ModelActions';
import {getStore} from 'redux-stores/Store';
import * as StorableActions from 'samples/StorableActions';
import StorableStore from 'samples/StorableStore';

export const MODEL_TYPE = 'STORABLE_SUMMARY';
export default class StorableSummaryManager {
  static requestFetch(id: string): void {
    requestFetch(this, id);
  }

  static async fetchMulti(storableIds: Array<string>): Promise<void> {
    try {
      getStore().dispatch(loadingStarted(MODEL_TYPE, storableIds));
      await StorableActions.bulkFetchSummaries(storableIds);
      // Deleted storables and storables that we have insufficient privilege to see are simply not included
      const inaccessibleStorableIds = storableIds.filter((id) => !StorableStore.getStorableSummary(id));
      getStore().dispatch(ModelActions.storablesFetchCompleted(inaccessibleStorableIds));
      getStore().dispatch(loadingCompleted(MODEL_TYPE, storableIds));
    } catch (e) {
      getStore().dispatch(loadingFailed(MODEL_TYPE, storableIds));
      throw e;
    }
  }

  static isKeyLoadedOrLoading(storableId: string): boolean {
    if (StorableStore.getStorableSummary(storableId)) {
      return true;
    }

    if (getStore().getState().models.inaccessibleStorableIds.includes(storableId)) {
      return true;
    }

    const loadingState = getStore().getState().models.loadingState;
    if (loadingState[MODEL_TYPE]) {
      return Boolean(loadingState[MODEL_TYPE][storableId]);
    }

    return false;
  }
}
